<ng-container>
    <div class="welcome-container">
      <h1>{{ 'WelcomeRelatedUser.Title' | translate }}</h1>
      <p>{{ 'WelcomeRelatedUser.Description' | translate }}</p>
      <button class="is-btn is-btn__outfill header__public-signin" (click)="startSignup()">{{ 'WelcomeRelatedUser.Start' | translate }}</button>
    </div>
  </ng-container>